import React from "react";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import Label from "./Label";

const defaultStyle =
  "mt-1 mb-2 border focus:ring-am-500 focus:border-black-500 block w-full text-black-500 sm:text-sm border-gray-300 disabled:opacity-50";

const defaultComponentStyle = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: "0",
    borderColor: state.isFocused ? "black" : "transparent",
    boxShadow: "none !important",
    "&:hover": {
      borderColor: "black",
    },
  }),
  singleValue: (provided, state) => ({
    ...provided,
    position: "absolute",
  }),
  input: (provided, state) => ({
    input: {
      border: 0,
      outline: 0,
      boxShadow: "none !important",
      borderColor: state.isFocused ? "black" : "transparent",
    },
  }),
  menu: (provided) => ({
    ...provided,
    whiteSpace: 'normal',  // Allow breaking on new lines
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  option: (provided, {data: {value}}) => ({
    ...provided,
    wordBreak: 'break-word',  // Force wrapping for long words
    whiteSpace: 'normal',     // Prevent text overflow
    display: 'block',         // Ensure it's a block-level element
    // Add padding to grouped options
    paddingLeft: typeof value === "string" && value.includes(".")
      ? "25px"
      : provided.paddingLeft,
  }),
};

const defaultInputStyle = {
  position: "absolute",
  opacity: 0,
  height: 0,
  padding: 0,
  margin: 0,
};

const SearchSelect = ({
  loadOptions,
  label,
  options,
  onChange,
  value,
  isMulti,
  CustomOption,
  CustomGroup,
  mainStyle = defaultStyle,
  componentStyle = defaultComponentStyle,
  inputStyle = defaultInputStyle,
  ...props
}) => {
  let component = null;
  const { required, disabled } = props;
  const components = CustomOption
    ? { Option: CustomOption, Group: CustomGroup }
    : {};
  if (!loadOptions /*|| isMulti*/) {
    component = (
      <Select
        components={components}
        styles={componentStyle}
        className={mainStyle}
        isSearchable={true}
        options={options}
        onChange={onChange}
        value={value}
        placeholder=""
        isMulti={isMulti}
        menuPortalTarget={document.body}
        {...props}
      />
    );
  } else {
    component = (
      <AsyncSelect
        components={components}
        // cacheOptions
        styles={componentStyle}
        value={value}
        loadOptions={loadOptions}
        onChange={onChange}
        className={mainStyle}
        placeholder=""
        isMulti={isMulti}
        menuPortalTarget={document.body}
        {...props}
      />
    );
  }
  return (
    <div className="flex flex-col mb-1">
      {label ? <Label disabled={props.isDisabled}>{label}</Label> : null}
      {component}
      {!disabled && (
        <input
          className="input-required"
          type="text"
          style={{ ...defaultInputStyle, ...inputStyle }}
          value={value === null ? "" : value}
          onChange={() => {}}
          tabIndex={-1}
          autoComplete="off"
          required={required}
          disabled={disabled}
        />
      )}
    </div>
  );
};

export default SearchSelect;
